import React from 'react';

import FuelTank from './fuel-tank.svg?react';

function FarmbotFuelTankIcon() {
  return <FuelTank width={18} />;
}

export default FarmbotFuelTankIcon;
